import { useTheme } from '@mui/material/styles';
export const useStyles = () => {
    const theme = useTheme();
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            marginTop: theme.spacing(3),
            paddingLeft: theme.spacing(16),
            color: theme.palette.primary.dark,
        },
        title: {
            marginBottom: theme.spacing(1),
            color: theme.palette.primary.dark,
        },
        list: {
            listStyle: 'unset',
            paddingLeft: theme.spacing(3),
            paddingTop: theme.spacing(2),
            '& > li': {
                marginBottom: theme.spacing(1.5),
                fontSize: '1rem',
            }
        }
    };
};
